/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import "../../styles/containers/ViewUsers.scss";
import Button from "../../components/Button";
import { connect } from "react-redux";
import Loader from "../../components/Loader";
import EditUser from "./editUser";
import { Grid } from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import { Auth, API } from "aws-amplify";

function AllUsers({ name, rights, id, handleOpen, email }) {
  return (
    <div className="All-Users col-12" id={id} key={id}>
      <Grid container className="container">
        <Grid item xs={12} sm={2}>
          <h1 className="heading">{name}</h1>
        </Grid>
        <Grid item xs={12} sm={5}>
          <h1 className="heading">{email}</h1>
        </Grid>
        <Grid item xs={12} sm={2}>
          <h1 className="heading">{rights}</h1>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button
            type="button"
            title="Edit"
            className="btn"
            onClick={(e) => handleOpen(e, id)}
          />
        </Grid>
      </Grid>
    </div>
  );
}

function ViewUsers({
  FetchedUser,
  FetchedUserError,
  FetchedUserSuccess,
  isFetchedUser,
  parkID,
}) {
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);
  const loader = useRef(null);
  const [userIndex, setUserIndex] = useState(null);
  const [group, setGroup] = useState("");
  const [loadMore, setLoadMore] = useState(true);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: "20px",
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    if (parkID) {
      const observer = new IntersectionObserver(handleObserver, options);
      if (loader.current) {
        observer.observe(loader.current);
      }
    }
  }, [parkID]);

  const handleOpen = (e, index) => {
    setOpen(true);
    setUser(allUsers[index]);
    setUserIndex(index);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchAllUsers = async (offset, limit) => {
    await API.get("AdminQueries", "/api/v1/getallusers", {
      queryStringParameters: {
        offset,
        limit,
        park_id: parseInt(parkID),
      },
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        if (res.message.rows.length) {
          setAllUsers((previousData) => [...previousData, ...res.message.rows]);
        } else {
          setLoadMore(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        let usersError = err?.response?.data?.message
          ? err?.response?.data?.message
          : err.message;
        toast.error(`Error in getting All Users ${usersError}`);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (FetchedUserSuccess && isFetchedUser) {
      setGroup(FetchedUser?.rights.toLowerCase());
    } else if (FetchedUserError) {
      toast.error(`Error in getting user info ${FetchedUserError}`);
    }
  }, [isFetchedUser]);

  useEffect(() => {
    if (loadMore && parkID) fetchAllUsers(offset, limit);
  }, [offset, parkID]);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setOffset((offset) => offset + 10);
    }
  };

  function updateUserFunc(user, index) {
    setAllUsers((previousData) => {
      let preData = [...previousData];
      preData[index] = user;
      return preData;
    });
  }

  return (
    <div
      className="ViewUsers"
      style={loading ? { height: "100vh" } : { height: "100%" }}
    >
      {open ? (
        <EditUser
          handleClose={handleClose}
          open={open}
          user={user}
          updateUserFunc={(user) => updateUserFunc(user, userIndex)}
        />
      ) : (
        ""
      )}
      <h1 className="heading-1"> View & Edit User(s)</h1>
      {loading ? (
        <Loader />
      ) : (
        allUsers.map((user, index) =>
          !(group === "admin" && user.rights.toLowerCase() === "superadmin") ? (
            <AllUsers
              name={user?.first_name}
              rights={user?.rights}
              id={index}
              key={index}
              handleOpen={handleOpen}
              email={user?.email}
            />
          ) : (
            ""
          )
        )
      )}
      <div className="loading" ref={loader}></div>
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    users: state?.users?.getAllUsers?.users,
    isFetched: state?.users?.getAllUsers?.isFetched,
    error: state?.users?.getAllUsers?.error,
    isFetchedUser: state?.users?.getUser?.isFetched,
    FetchedUserSuccess: state?.users?.getUser?.success,
    FetchedUserError: state?.users?.getUser?.error,
    FetchedUser: state?.users?.getUser?.user,
    parkID: state?.users?.getUser?.user?.park_id,
  };
}

export default connect(mapStateToProps, null)(ViewUsers);
